import { TipoDeRecurso } from '@/models/Recurso'
import { tituloDaToolbarPeloNomeDaRota } from '@/shareds/router-shareds'
import { RouteConfig } from 'vue-router'

const rotasDeSpedFiscal: RouteConfig[] = [
	{
		path: 'sped-fiscal',
		name: 'SPED Fiscal',
		components: {
			default: () => import('@/views/application/fiscal/TelaDeSpedFiscal.vue'),
			toolbar: () => import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: { toolbar: tituloDaToolbarPeloNomeDaRota },
		meta: {
			recurso: 'sped-fiscal' as TipoDeRecurso,
		},
	},
]

export default rotasDeSpedFiscal
